import React from 'react';
import s from './OrdersList.module.scss';
import Button from 'components/shared/Button';
import useGetServicesTeamsByServiceIdSingle from 'sdk/hooks/booking/useGetServicesTeamsByServiceIdSingle';
import { ReactComponent as TrashIcon } from 'images/new-icons/black-trash.svg';
import { format, parse } from 'date-fns';
import useGetAllServicePricingDurationByServiceIn from 'sdk/hooks/booking/useGetAllServicePricingDurationByServiceIn';

const OrdersList = ({
  handleNext,
  selectedServiceHistory,
  bookingTransactions,
  onDelete,
  price,
}) => {
  const serviceIds = selectedServiceHistory;
  const { data: services } = useGetAllServicePricingDurationByServiceIn(serviceIds);
  const teamIds = bookingTransactions.map(transaction => transaction.team_id);
  const { data: servicesTeams } = useGetServicesTeamsByServiceIdSingle(serviceIds, teamIds);

  const totalDuration = bookingTransactions.reduce(
    (sum, transaction) => sum + transaction.duration,
    0,
  );

  const formatTime = timeStr => {
    return format(parse(timeStr, 'HH:mm:ss', new Date()), 'h:mm a');
  };

  const formatDate = dateStr => {
    return format(parse(dateStr, 'yyyy-MM-dd', new Date()), 'd MMM');
  };

  return (
    <div className={s.orders_list}>
      <div className={s.orders_list_items}>
        {bookingTransactions.map((transaction, index) => {
          const serviceTeam = servicesTeams?.find(
            item =>
              item.service.id === selectedServiceHistory[index] &&
              item.teams.id === transaction.team_id,
          );
          const servicesPrice = services?.find(el => el.service === selectedServiceHistory[index]);

          return (
            <div key={index} className={s.order_card}>
              {/* Изображение */}
              <div className={s.order_card_image}>
                <img src={serviceTeam?.service?.image} alt={serviceTeam?.service?.name} />
              </div>

              {/* Контент */}
              <div className={s.order_card_content}>
                <div className={s.order_card_title}>{serviceTeam?.service?.name}</div>

                {/* Время и дата */}
                <div className={s.order_card_schedule}>
                  <div className={s.order_card_schedule_item}>
                    <span className={s.order_card_schedule_item_label}>Time:</span>
                    <span className={s.order_card_schedule_item_value}>
                      {formatTime(transaction.start_time)} - {formatTime(transaction.end_time)}
                    </span>
                  </div>
                  <div className={s.order_card_schedule_item}>
                    <span className={s.order_card_schedule_item_label}>Date:</span>
                    <span className={s.order_card_schedule_item_value}>
                      {formatDate(transaction.date)}
                    </span>
                  </div>
                </div>

                {/* Цена и удаление */}
                <div className={s.order_card_bottom}>
                  <div className={s.order_card_bottom_price}>﷼{servicesPrice?.price}</div>
                  <div className={s.order_card_bottom_delete} onClick={() => onDelete(index)}>
                    <TrashIcon />
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Футер */}
      <div className={s.footer}>
        <div className={s.footer_row}>
          <div className={s.footer_row_label}>Total time:</div>
          <div className={s.footer_row_value}>{totalDuration / 60} hours</div>
        </div>
        <div className={s.footer_row}>
          <div className={s.footer_row_label}>Total price:</div>
          <div className={s.footer_row_value}>﷼{price}</div>
        </div>
        <Button className={s.footer_button} wide darkGreen onClick={handleNext}>
          Book now
        </Button>
      </div>
    </div>
  );
};

export default OrdersList;
